import React, { useEffect, useState } from "react";
import { Box, Heading, VStack, Text } from "@chakra-ui/react";
import rentalsService from "../services/rentalsService";

const Trips = () => {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    rentalsService
      .getBookings()
      .then((res) => setBookings(res.data || []))
      .catch(() => setBookings([]));
  }, []);

  return (
    <Box p={6}>
      <Heading size="md">Trips</Heading>
      <VStack align="stretch" mt={4} spacing={3}>
        {bookings.length === 0 && <Text>No trips yet.</Text>}
        {bookings.map((b) => (
          <Box key={b._id} p={3} borderWidth={1} borderRadius="md">
            <Text fontWeight="bold">{b.assetName}</Text>
            <Text>{b.status}</Text>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default Trips;
